/* This file is autogenerated, see readme.md for instructions */
import PictureSvgIcon from '@bloomreach/banana-theme/icons/picture.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PictureIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PictureSvgIcon />
    </Icon>
  );
});

PictureIcon.displayName = 'PictureIcon';

export default PictureIcon;
